export default {
  set(key, obj) {
    localStorage.setItem(key, JSON.stringify(obj))
  },
  get(key) {
    let value = localStorage.getItem(key)
    if (typeof value === 'undefined') {
      return null
    }
    if (value === 'undefined') {
      return null
    }
    return JSON.parse(value);
  },
  remove(key) {
    localStorage.removeItem(key)
  }
}



// WEBPACK FOOTER //
// ./src/services/objectLocalStorage.js